/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExaBeaconIdDto } from './exaBeaconIdDto';
import { WorkstateConditionDto } from './workstateConditionDto';
import { AccountingConfigDto } from './accountingConfigDto';
import { CanValueMappingDto } from './canValueMappingDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface ImplementV2Dto {
  accounting1Conf?: AccountingConfigDto;
  accounting2Conf?: AccountingConfigDto;
  accounting3Conf?: AccountingConfigDto;
  accounting4Conf?: AccountingConfigDto;
  accounting5Conf?: AccountingConfigDto;
  active?: boolean;
  beacon?: ExaBeaconIdDto;
  beaconLastSeen?: string;
  canValueMappings?: { [key: string]: CanValueMappingDto };
  cost?: number;
  costPer?: string;
  deleted?: boolean;
  externalId?: string;
  foxId?: string;
  hitchToApplicationDistance?: number;
  id?: number;
  make?: string;
  model?: string;
  name?: string;
  overrideConditionsWithISOBUS?: boolean;
  owner?: EnterpriseIdDto;
  transportUnit?: string;
  transportValue?: number;
  type1?: number;
  type2?: number;
  type3?: number;
  updated?: string;
  workingWidth?: number;
  workstateConditions?: Array<WorkstateConditionDto>;
  year?: number;
}
